var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceReels(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5209 13.8611C42.059 6.57122 30.2192 6.05966 21.8527 10.0101C7.43392 16.8176 3.46388 37.2528 12.1318 47.5749C21.6896 58.9576 36.5003 58.0518 44.4524 52.281C54.7596 44.8016 60.2763 31.2571 53.3071 19.9779",
    stroke: "#F9F8F8",
    strokeWidth: 3.31773,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0175 23.303C23.991 23.7738 23.9508 24.243 23.9263 24.7138",
    stroke: "#F9F8F8",
    strokeWidth: 3.31773,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2938 23.2397C38.2912 23.7875 38.2926 24.3346 38.2965 24.8829",
    stroke: "#F9F8F8",
    strokeWidth: 3.31773,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0169 33.39C34.3638 32.3831 33.1526 31.3285 31.9181 31.1216C25.3654 30.0242 23.944 41.4978 28.5697 44.3877C30.9727 45.8899 33.7034 44.8022 35.1364 42.5311C36.66 40.1177 36.7112 35.9993 35.0169 33.39V33.39Z",
    stroke: "#F9F8F8",
    strokeWidth: 3.31773,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceReels);
export default __webpack_public_path__ + "static/media/face-reels.92c55329d04e76ef60cca66aa90f4bb0.svg";
export { ForwardRef as ReactComponent };